import React from "react";
import "./TopicListBanner.scss";
import SearchBar from "../SearchBar";

const TopicListBanner = (props: any) => {
    const { topicName, searchText, setSearchText, changeClassName, handleSearch, isNotVocabCenterPage,searchOnly } = props;
    return (
        <div className="topic-list" data-testid="topic-list-heading">
            <div className="topic-list-heading">
                <h3>{topicName}</h3>
            </div>
            <div className="topic-list-searchbar">
                <SearchBar
                    searchOnly={searchOnly}
                    searchText={searchText}
                    setSearchText={setSearchText}
                    changeClassName={changeClassName}
                    handleSearch={handleSearch}
                    isNotVocabCenterPage={isNotVocabCenterPage} />
            </div>
        </div>
    )
}

export default TopicListBanner;